export const normalizeBase64Payload = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  // Algunos backends devuelven "null"/"undefined" como string.
  const lowered = trimmed.toLowerCase();
  if (lowered === "null" || lowered === "undefined" || lowered === "n/a") return "";
  return trimmed;
};

export const isProbablyPdfBase64 = (value) => {
  const normalized = normalizeBase64Payload(value);
  if (!normalized) return false;

  // Un PDF en base64 típicamente arranca con "JVBERi0" (=%PDF-).
  // También validamos longitud mínima para evitar placeholders.
  if (normalized.length < 80) return false;
  return normalized.startsWith("JVBERi0");
};

export const hasAnyValidComprobanteInEstados = (orden) => {
  const estados = Array.isArray(orden?.estado) ? orden.estado : [];
  if (estados.length === 0) return false;

  return estados.some((e) => {
    const raw =
      e?.archivo ??
      e?.Archivo ??
      e?.comprobante ??
      e?.Comprobante ??
      "";
    return isProbablyPdfBase64(raw);
  });
};

